// extracted by mini-css-extract-plugin
export default {"label-mandatory-field":"expandableinput_label-mandatory-field__EfiLE","social-media-hyperlink":"expandableinput_social-media-hyperlink__oJPvC","input":"expandableinput_input__lb5O1"};